import React from 'react';
import Form from '../../../../components/Form/Form';

const Login = () => {
    return <Form />;
};

export default Login;
